import React, {Fragment} from 'react'
import {EventoInterior} from '../components/EventoInterior'
import Context from '../Context'

export const Evento = (props) => (

   
        <Context.Consumer>
        {
            ({song,changeSong}) => {
                return(
                <Fragment>
                    <EventoInterior song={song} changeSong={changeSong}  idjornada={props.idjornada}/>
                </Fragment>
                )
            }
        }
        </Context.Consumer>
            

)


